import { createFileRoute, redirect } from '@tanstack/react-router'
import { AdminLayout } from '@/components/layout/AdminLayout'
import { useAuthStore } from '@/store/authStore'

export const Route = createFileRoute('/_authenticated')({
  component: AdminLayout,
  beforeLoad: () => {
    const token = useAuthStore.getState().token
    if (!token) {
      throw redirect({ to: '/login' })
    }
  },
})
